// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-__slug-indexstyleGrid-container-bovqy{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-info-__slug-indexstyleGrid-grid-bmniw{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-info-__slug-indexstyleGrid-col6-bxlud{grid-column:span 6}.pages-info-__slug-indexstyleGrid-col3-cbmpu{grid-column:span 3}.pages-info-__slug-indexstyleGrid-col4-boggi{grid-column:span 4}.pages-info-__slug-indexstyleGrid-col9-boclr{grid-column:span 9}.pages-info-__slug-indexstyleGrid-col12-btqii{grid-column:span 12}.pages-info-__slug-indexstyleGrid-alignItemsStart-lebbi{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-info-__slug-indexstyleGrid-container-bovqy",
	"grid": "pages-info-__slug-indexstyleGrid-grid-bmniw",
	"col6": "pages-info-__slug-indexstyleGrid-col6-bxlud",
	"col3": "pages-info-__slug-indexstyleGrid-col3-cbmpu",
	"col4": "pages-info-__slug-indexstyleGrid-col4-boggi",
	"col9": "pages-info-__slug-indexstyleGrid-col9-boclr",
	"col12": "pages-info-__slug-indexstyleGrid-col12-btqii",
	"alignItemsStart": "pages-info-__slug-indexstyleGrid-alignItemsStart-lebbi"
};
module.exports = ___CSS_LOADER_EXPORT___;
